import { api } from "@king-ict/eupisi-ui/utils";

import ChildListDto from "../../models/Person/ChildListDto";

const apiUrlPrefix: string = "children";

export const getAllChildrenForListAsync = async () => {
  return api.get(`${apiUrlPrefix}/publicList`) as Promise<ChildListDto>;
};
